/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import { classNames as l } from "@progress/kendo-react-common";
const m = e.forwardRef(
  ({ orientation: r = "vertical", ...a }, n) => {
    const t = e.useRef(null), s = e.useRef(null);
    return e.useImperativeHandle(t, () => ({ element: s.current })), e.useImperativeHandle(n, () => t.current), /* @__PURE__ */ e.createElement(
      "span",
      {
        ...a,
        className: l("k-input-separator", a.className, `k-input-separator-${r}`)
      }
    );
  }
);
m.displayName = "KendoReactInputSeparator";
export {
  m as InputSeparator
};
